import React from 'react';

import { ActivityStatus, AssetContractsResponseItem, useGetAssetsContractsAssetContract } from '@ping/api';
import { useIsUserLoggedIn } from '@ping/hooks';
import { useUserInformationStore } from '@ping/stores/userInformation.store';

export function useAssetContractStatus() {
  const isUserLoggedIn = useIsUserLoggedIn();
  const isUserProfileActive = useUserInformationStore(state => state.activityStatus === ActivityStatus.Active);
  const { data, isLoading, isError } = useGetAssetsContractsAssetContract({
    query: {
      enabled: isUserLoggedIn && isUserProfileActive,
    },
  });

  const contractsByAssetId = React.useMemo(() => {
    const map = new Map<string, AssetContractsResponseItem>();
    if (!data?.assets) return map;

    for (const asset of data.assets) {
      if (asset.assetId) {
        map.set(asset.assetId.toLowerCase(), asset);
      }
    }
    return map;
  }, [data]);

  const getAssetContract = React.useCallback(
    (assetId: string): AssetContractsResponseItem | undefined => {
      return contractsByAssetId.get(assetId.toLowerCase());
    },
    [contractsByAssetId]
  );

  const isContractSigned = React.useCallback(
    (assetId: string): boolean => {
      const asset = getAssetContract(assetId);
      if (!asset) return true;
      return !!asset.isSigned;
    },
    [getAssetContract]
  );

  return {
    contractsByAssetId,
    getAssetContract,
    isContractSigned,
    isLoading,
    isError,
  };
}
